// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';
import { Box } from '../../grid';
import { PrefixedInput } from '../../form';

type State = {
  from: string,
  to: string,
};

type Props = {
  from: number, // eslint-disable-line react/no-unused-prop-types
  to: number, // eslint-disable-line react/no-unused-prop-types
  onValuesUpdated: (from: number, to: number) => void,
};

const InputContainer = styled<any, Theme>('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

class RangeInput extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      from: '',
      to: '',
    };
  }

  static getDerivedStateFromProps(props: Props, prevState: State): State {
    const { from, to } = props;
    if (prevState.from === from && prevState.to === to) {
      return prevState;
    }

    return {
      from: from.toString(),
      to: to.toString(),
    };
  }

  updateState = (type: string, e: SyntheticInputEvent<HTMLInputElement>) => {
    const { onValuesUpdated } = this.props;
    this.setState({ [type]: e.target.value }, () => {
      const { from, to } = this.state;

      const toNr = parseInt(to, 10);
      const fromNr = parseInt(from, 10);

      if (toNr >= fromNr) {
        onValuesUpdated(fromNr, toNr);
      }
    });
  }

  render() {
    const { from, to } = this.state;
    return (
      <InputContainer>
        <PrefixedInput onChange={e => this.updateState('from', e)} value={from} />
        <Box pr="1rem" pl="1rem">-</Box>
        <PrefixedInput onChange={e => this.updateState('to', e)} value={to} />
      </InputContainer>
    );
  }
}

export default RangeInput;
